// External Imports
import { IoMdClose } from "react-icons/io";
import { MdWarning } from "react-icons/md";
import Modal from "./Modal";

// Internal Imports

/** ========================================================================
 * * WarningModal Component
 * This component renders a modal that displays a warning.
 * ========================================================================== */

export default function WarningModal({ open, setOpen, warning }) {
  return (
    <Modal open={open} setOpen={setOpen}>
      <div className="container p-6 lg:max-w-[40vw]">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2 text-red-700">
            <MdWarning className="w-5 h-5" />
            <p className="text-lg font-semibold">Error</p>
          </div>
          <IoMdClose onClick={() => setOpen(false)} className="icon" />
        </div>
        <p className="font-semibold">{warning}</p>
      </div>
    </Modal>
  );
}
